import { queryOptions, useQuery } from '@tanstack/react-query';
import { type Group, groupScheme } from '@/models/group/group-info';
import { generateListResponseScheme, type ListRespondedWith } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export const groupsQueryOptions = queryOptions({
  queryKey: ['/GetMyGroup'],
  queryFn: ({ signal }) =>
    fetcher<ListRespondedWith<Group>>('/GetMyGroup', undefined, {
      signal,
      schema: generateListResponseScheme(groupScheme),
      validResponseCodes: [0, 1],
    }).then((response) => {
      if (!response?.Data) return {};

      return response.Data.reduce<Record<number, Group>>((accu, group, index) => {
        accu[group.ID] = { ...group, Order: index };
        return accu;
      }, {});
    }),
});

export default function useGroups() {
  const query = useQuery(groupsQueryOptions);

  return {
    groups: query.data ?? {},
    ...query,
  };
}

export function useGroup(groupId: Nullable<number>) {
  const query = useQuery({
    ...groupsQueryOptions,
    select: (data) => (data && groupId ? data[groupId] : undefined),
  });

  return {
    group: query.data,
    isJoined: Boolean(query.data),
    ...query,
  };
}
